<ng-template #table>
  <table [attr.aria-label]="'Pfandrechtschuldner' | translate" [title]="" class="cap-table-detail">
    <thead>
      <tr>
        <th>{{"Art" | translate}}</th>
        <th>{{"Schuldner" | translate}}</th>
        <th>{{"Rechtsgrund" | translate}}</th>
      </tr>
    </thead>
    <tbody>
      @for (schuldner of recht.schuldner; track schuldner) {
        @for (version of schuldner.versions; track version) {
          <tr>
            <td [capHistinfo]="version.histInfo">{{ version.schuldnerrolle?.text | translateName }}</td>
            <td>
              <cap-kompakt-persongb
                [auskunftsperre]="version.personGb.auskunftsperre"
                [capHistinfo]="version.histInfo"
                [item]="version.personGb"
                [itemMasterId]="version.personGb.id"></cap-kompakt-persongb>
              <cap-kompakt-timepoint [item]="version.histInfo.bisTimePoint" loeschgeschaeft></cap-kompakt-timepoint>
            </td>
            <td>
              @for (rechtsgrund of schuldner.rechtsgruende; track rechtsgrund) {
                <p [capHistinfo]="version.histInfo">
                  <cap-rechtsgrund [rechtsgrund]="rechtsgrund"></cap-rechtsgrund>
                </p>
              }
            </td>
          </tr>
        }
      }
    </tbody>
  </table>
</ng-template>

@if (!recht || recht?.schuldner?.length == 0) {
  <ng-template [ngTemplateOutlet]="keine"></ng-template>
} @else {
  <table [attr.aria-label]="'Pfandrechtschuldner' | translate" [title]="" class="cap-table-detail">
    <thead>
      <tr>
        <th>{{"Art" | translate}}</th>
        <th>{{"Schuldner" | translate}}</th>
        <th>{{"Rechtsgrund" | translate}}</th>
      </tr>
    </thead>
    <tbody>
      @for (schuldner of recht.schuldner; track schuldner) {
        @for (version of schuldner.versions; track version) {
          <tr>
            <td [capHistinfo]="version.histInfo">{{ version.schuldnerrolle?.text | translateName }}</td>
            <td>
              <cap-kompakt-persongb
                [capHistinfo]="version.histInfo"
                [item]="version.personGb"
                [itemMasterId]="version.personGb.id"></cap-kompakt-persongb>
              <cap-kompakt-timepoint [item]="version.histInfo.bisTimePoint" loeschgeschaeft></cap-kompakt-timepoint>
            </td>
            <td>
              @for (rechtsgrund of schuldner.rechtsgruende; track rechtsgrund) {
                <p [capHistinfo]="version.histInfo">
                  <cap-rechtsgrund [rechtsgrund]="rechtsgrund"></cap-rechtsgrund>
                </p>
              }
            </td>
          </tr>
        }
      }
    </tbody>
  </table>
}
<ng-template #keine>
  <div class="mb-2">
    <span>{{"Keine" | translate}}</span>
  </div>
</ng-template>
